module.exports = __webpack_public_path__ + "static/media/Team 16 - Move 78.9edaccb0.png";